module.exports = __webpack_public_path__ + "static/flexibilidade-d70baea0d7f41a828f8757ac540d8962.png";